"use client";

/**
 * <InfoTip> — a small inline ⓘ affordance with a hover/focus tooltip.
 *
 * Shared across the dashboard (settings usage meters, billing plan grid)
 * and the marketing landing page to attach contextual help to a label
 * without an always-on block of fine print. Client island so it can sit
 * inside server-rendered surfaces; the Radix TooltipProvider is mounted
 * once at the root layout, so this works on any page under it.
 */

import * as React from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function InfoTip({ label, text }: { label: string; text: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className="inline-flex items-center justify-center align-middle text-[color:var(--ink-3)] hover:text-[color:var(--ink)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--shark-accent)]"
        >
          <Info className="h-3 w-3" aria-hidden />
        </button>
      </TooltipTrigger>
      <TooltipContent className="leading-relaxed">{text}</TooltipContent>
    </Tooltip>
  );
}
